import { api_GET, api_POST, api_PUT, api_POST_Unauthorize } from "api/axios.js";

const usuario_api =
{
    getAll: function () {
        const promise = new Promise((resolve, reject) => {
            api_GET(`usuario`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getItem: function (id) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`usuario/getItem/${id}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    post: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`usuario`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    put: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`usuario`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    authenticate: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_POST_Unauthorize(`usuario/authenticate`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    esqueceu_senha: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_POST_Unauthorize(`usuario/EsqueceuSenha`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    trocar_senha: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`usuario/TrocarSenha`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    }
}

export default usuario_api
